const LowvoltageTime: { [key: string]: string } = {
  "1": "6h",
  "2": "12h",
  "3": "24h",
  "4": "48h",
};

export default LowvoltageTime;
